<template>
  <div>
    <template v-if="isLoading">
      <div class="skeleton-checkbox-group">
        <div v-for="n in 3" :key="n" class="skeleton skeleton-checkbox" :style="skeletonStyle"></div>
      </div>
    </template>

    <template v-else-if="error">
      <div class="d-flex" style="gap: 8px; flex-wrap: wrap;">
        <p class="text-danger mb-2">{{ errorMessage }}</p>
        <b-button size="sm" variant="outline-danger" @click="$emit('retry')">
          Coba Lagi
        </b-button>
      </div>
    </template>

    <template v-else>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  name: "StateCheckboxHandler",
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: null,
    },
    errorMessage: {
      type: String,
      default: "Gagal memuat data.",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    skeletonStyle() {
      return {
        maxWidth: this.fullWidth ? "100%" : "350px",
      };
    },
  }
};
</script>
